import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAgent } from '@obvious.tech/constellation'

export const Agent = defineEntity('Agent', {
  endpoint: 'units/api/Agent',
  schema: SNoop<IAgent>(),
})
